import { ArrowBackOutline } from '@styled-icons/evaicons-outline/ArrowBackOutline'
import * as React from 'react'
import styled from 'styled-components'

import type { IEntry } from '@app/domain/instrument/instrument.interface'

import {
  HeaderContainer,
  ScreenContent,
  InstrumentScreenContent,
} from './content-layout'
import { BackButton, ContinueButton, Control, ControlRow } from './controls'

const ScreenHeader = styled.div`
  text-align: center;
  color: ${(props) => props.theme.colors.primary};
  font-size: 16pt;
  font-weight: 500;
`

interface IntakeInformationProps {
  header?: string
  entry?: IEntry
  instrumentId: string
  content?: string
  handleGoBack?: () => void
  handleContinue?: () => void
  handleSubmit?: (
    instrumentId: string,
    responses: Record<string, string>,
  ) => void
}

interface IntakeInformationState {
  responses: Record<string, string>
}

export class IntakeInformation extends React.Component<
  IntakeInformationProps,
  IntakeInformationState
> {
  constructor(props) {
    super(props)
    this.state = {
      responses: this.props.entry ? this.props.entry.responses : {},
    }
  }

  componentDidMount() {
    this.setState({
      responses: this.props.entry ? this.props.entry.responses : {},
    })
  }

  componentDidUpdate(nextProps) {
    const { entry } = this.props
    if (nextProps.entry !== entry) {
      this.setState({
        responses: this.props.entry ? this.props.entry.responses : {},
      })
    }
  }

  handleResponseChange = (question: string, value: string) => {
    this.setState({
      responses: {
        ...this.state.responses,
        [question]: value,
      },
    })
  }

  renderBackButton = (goBack?: () => void) => {
    if (goBack) {
      return (
        <BackButton onClick={goBack}>
          <ArrowBackOutline size="45" />
        </BackButton>
      )
    } else {
      return <></>
    }
  }

  renderHeader = (header?: string) => {
    if (!header) {
      return null
    }

    return (
      <HeaderContainer>
        <ScreenHeader dangerouslySetInnerHTML={{ __html: header }} />
      </HeaderContainer>
    )
  }

  renderContent = (content?: string) => {
    if (content) {
      return <div dangerouslySetInnerHTML={{ __html: content }} />
    } else {
      return <></>
    }
  }

  renderContinueButton = () => {
    if (this.props.handleSubmit) {
      return (
        <ContinueButton
          onClick={() =>
            this.props.handleSubmit(this.props.entry.id, this.state.responses)
          }
        >
          Continue
        </ContinueButton>
      )
    } else {
      return <></>
    }
  }

  render() {
    const { handleGoBack, header, content } = this.props
    return (
      <ScreenContent>
        {this.renderHeader(header)}
        <InstrumentScreenContent>
          {this.renderContent(content)}
        </InstrumentScreenContent>
        <ControlRow>
          <Control>{this.renderBackButton(handleGoBack)}</Control>
          <Control>{this.renderContinueButton()}</Control>
          <Control />
        </ControlRow>
      </ScreenContent>
    )
  }
}
